export const GET_TRANSACTION = 'RPT_TAX_CLEARANCE/get_transaction';
export const APPROVE_TRANSACTION = 'RPT_TAX_CLEARANCE/approve_transaction';
export const REJECT_TRANSACTION = 'RPT_TAX_CLEARANCE/reject_transaction';
export const SHOW_TRANSACTION = 'RPT_TAX_CLEARANCE/show_transaction';
export const START_ASSESSMENT = 'RPT_TAX_CLEARANCE/start_assessment';
export const ASSESS_RECEIPT = 'RPT_TAX_CLEARANCE/assess_receipt';
export const RECEIVE_TRANSACTION = 'RPT_TAX_CLEARANCE/receive_transaction';
export const GET_TRANSACTION_COUNT = 'RPT_TAX_CLEARANCE/get_transaction_count';
export const GENERATE_TRANSMITTAL = 'RPT_TAX_CLEARANCE/generate_transmittal';
export const REASSESS = 'RPT_TAX_CLEARANCE/reassess';

export const RPT_TAX_CLEARANCE_TRANSMITTAL =
  'api/v1/administrators/rptax_clearance/transmittal/view';

export const RPT_TAX_CLEARANCE_REPRINT_TRANSMITTAL =
  'api/v1/administrators/transaction_histories/rptax_clearance/transmittal/reprint';

export const RPT_TAX_CLEARANCE_SOA =
  'api/v1/administrators/transaction_histories/rptax_clearance/{id}/soa';

export const RPT_TAX_CLEARANCE_OR =
  'api/v1/administrators/transaction_histories/rptax_clearance/{id}/or';

export const RPT_TAX_CLEARANCE =
  'api/v1/administrators/transaction_histories/rptax_clearance/{id}/clearance';

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
};
